export default {
  xxs: '390px',
  xs: '700px',
  sm: '960px',
  md: '1280px',
  lg: '1920px',
  mobileKeyboardHeight: '400px',
  macbookHeight: '800px',
};
